import { render } from "./ErrorPopup.vue?vue&type=template&id=5d0238d4&scoped=true"
import script from "./ErrorPopup.vue?vue&type=script&lang=js"
export * from "./ErrorPopup.vue?vue&type=script&lang=js"

import "./ErrorPopup.vue?vue&type=style&index=0&id=5d0238d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0238d4"]])

export default __exports__